import { DefaultBsComponent } from 'libs/growth-platform-brand-system-v2/src/types/module';
import React from 'react';
import { classNames } from '../../utils/style';
import { ImageProps } from '../Image/types';
import { Image } from '../Image';

export interface SimpleCardProps extends DefaultBsComponent {
  title: string;
  subtitle?: string;
  cta?: any;
  image: ImageProps;
  classObject?: ClassObject;
  onClick?: () => void;
}

type ClassObject = {
  base?: string;
  imgContainer?: string;
  img?: string;
  content?: string;
  title?: string;
  subtitle?: string;
};

export const SimpleCard: React.FC<SimpleCardProps> = ({
  as = 'div',
  title,
  subtitle,
  cta,
  image,
  classObject,
  ...props
}) => {
  const Component = as;
  return (
    <Component
      role="button"
      tabIndex={0}
      className={classNames(
        'SimpleCard flex h-full flex-col overflow-hidden',
        as === 'div' && 'cursor-default',
        classObject?.base,
      )}
      {...props}
    >
      <div
        className={classNames(
          'relative w-full overflow-hidden',
          classObject?.imgContainer,
        )}
      >
        <Image
          draggable={false}
          src={image.src}
          alt={image.alt}
          className={classNames(classObject?.img)}
          sizes={image.sizes}
          pixelDensity={image.pixelDensity || 'image'}
          width={image.width}
          height={image.height}
        />
      </div>
      <div className={classNames('flex flex-1 flex-col', classObject?.content)}>
        <h4 className={classObject?.title}>{title}</h4>
        {subtitle && <p className={classObject?.subtitle}>{subtitle}</p>}
        {cta && <div className="mt-auto">{cta}</div>}
      </div>
    </Component>
  );
};
